import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { SelectedWebsalesUser, WebsalesUser, WebsalesUsersManagementState } from './types'

export const initialState: WebsalesUsersManagementState = {
  isLoading: false,
  items: [],
  selectedWebsalesUser: {
    id: 0,
    username: '',
    password: '',
    is_active: true,
  },
  error: null,
}

const fetchListRequestHandler = (state: WebsalesUsersManagementState) => {
  state.isLoading = true
  state.error = null
}

const fetchListSuccessHandler = (state: WebsalesUsersManagementState, action: PayloadAction<WebsalesUser[]>) => {
  state.isLoading = false
  state.items = action.payload
}

const fetchListFailureHandler = (state: WebsalesUsersManagementState, action: PayloadAction<string>) => {
  state.isLoading = false
  state.error = action.payload
}

const setSelectedWebsalesUserHandler = (
  state: WebsalesUsersManagementState,
  action: PayloadAction<SelectedWebsalesUser>,
) => {
  state.selectedWebsalesUser = action.payload
}

const clearWebsalesUsersManagementHandler = () => initialState

export const WebsalesUsersManagementSlice = createSlice({
  name: 'websalesUsersManagement',
  initialState,
  reducers: {
    fetchListRequest: fetchListRequestHandler,
    fetchListSuccess: fetchListSuccessHandler,
    fetchListFailure: fetchListFailureHandler,
    setSelectedWebsalesUser: setSelectedWebsalesUserHandler,
    clearWebsalesUsersManagement: clearWebsalesUsersManagementHandler,
  },
})

export const {
  fetchListRequest,
  fetchListSuccess,
  fetchListFailure,
  setSelectedWebsalesUser,
  clearWebsalesUsersManagement,
} = WebsalesUsersManagementSlice.actions

export default WebsalesUsersManagementSlice.reducer
